import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { GetColourArray } from "../../components/Common";
import { Palette } from "../../AppConfig";
import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_CheckBox from "../../components/BSL_CheckBox";
import BSL_Select from "../../components/BSL_Select";
import BSL_ColourSelector from "../../components/BSL_ColourSelector";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import { updateAreaSpecificationGableParameters, updateAreaSpecificationShape } from "../../redux_store/jobState";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import * as CONFIG from "../../redux_store/configState";
import BSL_Dialog from "../../components/BSL_Dialog";
import BSL_TextInput from "../../components/BSL_TextInput";

const useStyles = makeStyles({
    root: {
        padding: "0px 8px 8px 8px",
    },
    sectionHeader: {
        font: "16pt 'Univers45', sans-serif",
        fontWeight: "400",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        paddingTop: "12px",
        paddingBottom: "8px",
        whiteSpace: "nowrap",
        textAlign: "start",
        paddingLeft: "8px",
    },
    sectionContainer: {
        font: "18pt 'Univers45', sans-serif",
        fontWeight: "400",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        display: "flex",
        paddingBottom: "5px",
    },
    helperText: {
        flex: "1",
        font: "13px 'Univers45', sans-serif",
        color: Palette.Control.DarkGrey,
        textAlign: "start",
        padding: "4px 0px 4px 10px",
        whiteSpace: "normal",
    },
});

export default function SpecPitchedGableOptions(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { areaIndex } = props;
    const infill_types = useSelector((state) => state.config.infill_types);
    const beam_types = useSelector((state) => state.config.beam_types);
    const colour_arrays = useSelector((state) => state.config.colour_arrays);
    const job = useSelector((state) => state.job);
    const areaSpecifications = useSelector((state) => state.job?.AreaSpecifications?.[areaIndex]);
    const gableParameters = areaSpecifications?.[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS];
    const ShapeParameters = areaSpecifications?.SHAPE;
    const designType = areaSpecifications?.SHAPE.DesignType;
    const area_config = useSelector((state) => state.config?.design_options?.[designType]);
    const RoofType1 = areaSpecifications?.SHAPE.RoofType1;
    const RoofType2 = areaSpecifications?.SHAPE.RoofType2;
    const designsubType = areaSpecifications?.SHAPE.DesignSubType;

    const [openDialog, setOpenDialog] = React.useState(false);
    const [dialogMessage, setDialogMessage] = React.useState("");
    const [dialogTitle, setDialogTitle] = React.useState("");

    const openMessageBox = (title, message) => {
        setDialogTitle(title);
        setDialogMessage(message);
        setOpenDialog(true);
    };

    let is_cyclonic = false;
    let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    if (region === "C" || region === "D") {
        is_cyclonic = true;
    }

    let infill_beam_options = ["656510", "1086510", "1586510"];
    if (area_config?.infill_beam?.options) {
        infill_beam_options = area_config?.infill_beam?.options;
    }

    if (window.LYSAGHT) {
        //infill beam is matched with EDGE BEAM (BEAMTYPE3)
        infill_beam_options = [areaSpecifications[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.BeamType3];
    }

    let beam_menu_items = [];
    for (let beam_name of infill_beam_options) {
        const beam = beam_types?.[beam_name];
        if (beam) {
            if (beam)
                beam_menu_items.push({
                    Key: beam_name,
                    Display: beam.name ? beam.name : beam_name,
                    Thumbnail: beam.thumbnail,
                });
        }
    }

    const items = [];

    items.push({
        Key: "No Beams",
        Display: "None (No Beams)",
        Thumbnail: null,
    });
    items.push({
        Key: "None",
        Display: "Infill Beams Only",
        Thumbnail: null,
    });

    if (area_config?.infill_options)
        for (let infill_name of area_config?.infill_options) {
            const infill = infill_types?.[infill_name];
            if (infill) {
                let disabled = false;
                let disabledTooltip = null;

                if (infill.allow_cyclonic === false && is_cyclonic) {
                    disabled = true;
                    disabledTooltip = "Not available in Cyclonic";
                }

                items.push({
                    Key: infill_name,
                    Display: infill?.name,
                    Thumbnail: infill?.thumbnail,
                    disabled: disabled,
                    disabledTooltip: disabledTooltip,
                });
            }
        }

    const selectedInfillFront = infill_types?.[gableParameters.TrussInfill1];
    const selectedInfillBack = infill_types?.[gableParameters.TrussInfill2];

    let label1 = "Front Infill";
    let label2 = "Back Infill";
    let label3 = "Left Gable Infill Options";
    let label4 = "Right Gable Infill Options";

    if (designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
        label1 = "Left Infill";
        label2 = "Right Infill";
        if (designsubType === CONFIG.DESIGN_SUBTYPES.PROJECTION) {
            label1 = "Back Infill";
            label2 = "Front Infill";
            label3 = "Back Gable Infill Options";
            label4 = "Front Gable Infill Options";
        }
    }

    let colourMatch = {
        "Match Rafter": areaSpecifications?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.BeamCol1,
    };

    return (
        <div className={classes.root}>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader style={{ paddingTop: "0px" }}>{label3}</BSL_Common.SectionHeader>

                {!window.LYSAGHT && (
                    <BSL_Select
                        style={{ flex: 1 }}
                        value={gableParameters.InfillBeamType}
                        tight={true}
                        items={beam_menu_items}
                        label={"Infill Beam Size"}
                        onChange={(e) => {
                            let error = dispatch(
                                updateAreaSpecificationGableParameters(
                                    Number(areaIndex),
                                    null,
                                    "InfillBeamType",
                                    e.target.value
                                )
                            );
                            if (error && error.error) {
                                openMessageBox("", <>{error.message}</>);
                            }
                        }}
                    />
                )}

                <BSL_Common.SectionRow>
                    <BSL_Select
                        style={{ flex: 1, flexBasis: "100%" }}
                        value={gableParameters.TrussInfill1}
                        disabled={designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && RoofType1 === "Hip"}
                        tight={true}
                        items={items}
                        label={label1}
                        onChange={(e) => {
                            let error = dispatch(
                                updateAreaSpecificationGableParameters(
                                    Number(areaIndex),
                                    null,
                                    "TrussInfill1",
                                    e.target.value
                                )
                            );
                            if (error && error.error) {
                                openMessageBox(error?.title, <>{error.message}</>);
                            }
                        }}
                    />
                    {!selectedInfillFront?.allow_display_colour && (
                        <BSL_ColourSelector
                            tight
                            mini={false}
                            disabled={designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && RoofType1 === "Hip"}
                            label="Colour"
                            colourList={selectedInfillFront?.colours}
                            value={gableParameters.TrussInfillColour1}
                            onChange={(value) => {
                                let error = dispatch(
                                    updateAreaSpecificationGableParameters(
                                        Number(areaIndex),
                                        null,
                                        "TrussInfillColour1",
                                        value
                                    )
                                );
                                if (error && error.error) {
                                    openMessageBox(error?.title, <>{error.message}</>);
                                }
                            }}
                        />
                    )}
                    {selectedInfillFront?.allow_display_colour && (
                        <BSL_ColourSelector
                            custom_select
                            tight
                            mini={false}
                            disabled={designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && RoofType1 === "Hip"}
                            label="Colour"
                            value={gableParameters.TrussInfillDisplayColour1}
                            onChange={(value) => {
                                let error = dispatch(
                                    updateAreaSpecificationGableParameters(
                                        Number(areaIndex),
                                        null,
                                        "TrussInfillDisplayColour1",
                                        value
                                    )
                                );
                                if (error && error.error) {
                                    openMessageBox(error?.title, <>{error.message}</>);
                                }
                            }}
                        />
                    )}

                    <BSL_ColourSelector
                        tight
                        mini
                        disabled={designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && RoofType1 === "Hip"}
                        label="Flashing"
                        colourList={["Match Rafter", ...GetColourArray("Colorbond", colour_arrays)]}
                        value={gableParameters.InfillFlashingColourMatch1}
                        colourMatch={colourMatch}
                        onChange={(value) => {
                            let error = dispatch(
                                updateAreaSpecificationGableParameters(
                                    Number(areaIndex),
                                    null,
                                    "InfillFlashingColourMatch1",
                                    value
                                )
                            );
                            if (error && error.error) {
                                openMessageBox(error?.title, <>{error.message}</>);
                            }
                        }}
                    />
                </BSL_Common.SectionRow>
                {selectedInfillFront?.allow_display_colour && (
                    <div className={classes.helperText}>
                        {"Choose a display colour, but product is supplied as '" +
                            gableParameters.TrussInfillColour1 +
                            "'"}
                    </div>
                )}

                {!window.LYSAGHT && (
                    <SegmentedButtonGroup
                        label={label1 + " Lining Alignment"}
                        tight
                        value={Number(gableParameters.InfillInset1)}
                        items={[
                            { Key: 0, Display: "Outside of Frame" },
                            { Key: 1, Display: "Inside of Frame" },
                        ]}
                        onChange={(e, value) => {
                            let error = dispatch(
                                updateAreaSpecificationGableParameters(Number(areaIndex), null, "InfillInset1", value)
                            );
                            if (error && error.error) {
                                openMessageBox(error?.title, <>{error.message}</>);
                            }
                        }}
                    />
                )}

                <SegmentedButtonGroup
                    label={label1 + " Strut"}
                    tight
                    value={Number(gableParameters.HasInfillStrut1)}
                    items={[
                        { Key: 0, Display: "No Strut" },
                        { Key: 1, Display: "Infill Strut" },
                    ]}
                    onChange={(e, value) => {
                        let error = dispatch(
                            updateAreaSpecificationGableParameters(Number(areaIndex), null, "HasInfillStrut1", value)
                        );
                        if (error && error.error) {
                            openMessageBox(error?.title, <>{error.message}</>);
                        }
                    }}
                />

                {designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && (
                    <BSL_TextInput
                        label={label1.replace("Infill", "") + " Frame Overhang"}
                        value={ShapeParameters?.OH_Left}
                        tight
                        min={0}
                        max={area_config?.max_frame_overhang ? area_config?.max_frame_overhang : 1200}
                        endAdornment="mm"
                        disabled={RoofType1 !== "Gable"}
                        style={{
                            maxWidth: "100px",
                        }}
                        onChange={(Value) => {
                            let error = dispatch(
                                updateAreaSpecificationShape(Number(areaIndex), null, "OH_Left", Value)
                            );
                        }}
                        disabledTooltip={"Only allowed for a Gable End Type"}
                    />
                )}

                {(areaSpecifications[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.HasRidgeBeam === 0 || window.LYSAGHT) &&
                    areaSpecifications[BASIC_SPECS_SECTIONS.SHAPE]?.OH_Left > 0 && (
                        <SegmentedButtonGroup
                            label={label1 + " Frame Overhang Position"}
                            tight
                            value={Number(gableParameters.InfillEndAlign1)}
                            items={
                                areaSpecifications[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.PortalPostType === 0
                                    ? [
                                          { Key: 1, Display: "At The End" },
                                          {
                                              Key: 0,
                                              Display: "Inset with Rafters at OH Setback",
                                          },
                                      ]
                                    : [
                                          { Key: 1, Display: "At The End, Rafters at OH Setback" },
                                          { Key: 2, Display: "At The End, No Rafters at OH Setback" },
                                          {
                                              Key: 0,
                                              Display: "Inset with Rafters at OH Setback",
                                          },
                                      ]
                            }
                            onChange={(e, value) => {
                                let error = dispatch(
                                    updateAreaSpecificationGableParameters(
                                        Number(areaIndex),
                                        null,
                                        "InfillEndAlign1",
                                        value
                                    )
                                );
                                if (error && error.error) {
                                    openMessageBox(error?.title, <>{error.message}</>);
                                }
                            }}
                        />
                    )}

                <BSL_Common.SectionHeader style={{ paddingTop: "12px" }}>{label4}</BSL_Common.SectionHeader>

                <BSL_Common.SectionRow>
                    <BSL_Select
                        style={{ flex: 1, flexBasis: "100%" }}
                        value={gableParameters.TrussInfill2}
                        disabled={designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && RoofType2 === "Hip"}
                        tight={true}
                        items={items}
                        label={label2}
                        onChange={(e) => {
                            let error = dispatch(
                                updateAreaSpecificationGableParameters(
                                    Number(areaIndex),
                                    null,
                                    "TrussInfill2",
                                    e.target.value
                                )
                            );
                            if (error && error.error) {
                                openMessageBox(error?.title, <>{error.message}</>);
                            }
                        }}
                    />
                    {!selectedInfillBack?.allow_display_colour && (
                        <BSL_ColourSelector
                            tight
                            mini={false}
                            disabled={designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && RoofType2 === "Hip"}
                            label="Colour"
                            colourList={selectedInfillBack?.colours}
                            value={gableParameters.TrussInfillColour2}
                            onChange={(value) => {
                                let error = dispatch(
                                    updateAreaSpecificationGableParameters(
                                        Number(areaIndex),
                                        null,
                                        "TrussInfillColour2",
                                        value
                                    )
                                );
                                if (error && error.error) {
                                    openMessageBox(error?.title, <>{error.message}</>);
                                }
                            }}
                        />
                    )}
                    {selectedInfillBack?.allow_display_colour && (
                        <BSL_ColourSelector
                            custom_select
                            tight
                            mini={false}
                            disabled={designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && RoofType2 === "Hip"}
                            label="Colour"
                            value={gableParameters.TrussInfillDisplayColour2}
                            onChange={(value) => {
                                let error = dispatch(
                                    updateAreaSpecificationGableParameters(
                                        Number(areaIndex),
                                        null,
                                        "TrussInfillDisplayColour2",
                                        value
                                    )
                                );
                                if (error && error.error) {
                                    openMessageBox(error?.title, <>{error.message}</>);
                                }
                            }}
                        />
                    )}
                    <BSL_ColourSelector
                        tight
                        mini
                        disabled={designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && RoofType2 === "Hip"}
                        label="Flashing"
                        colourList={["Match Rafter", ...GetColourArray("Colorbond", colour_arrays)]}
                        value={gableParameters.InfillFlashingColourMatch2}
                        colourMatch={colourMatch}
                        onChange={(value) => {
                            let error = dispatch(
                                updateAreaSpecificationGableParameters(
                                    Number(areaIndex),
                                    null,
                                    "InfillFlashingColourMatch2",
                                    value
                                )
                            );
                            if (error && error.error) {
                                openMessageBox(error?.title, <>{error.message}</>);
                            }
                        }}
                    />
                </BSL_Common.SectionRow>
                {selectedInfillBack?.allow_display_colour && (
                    <div className={classes.helperText}>
                        {"Choose a display colour, but product is supplied as '" +
                            gableParameters.TrussInfillColour1 +
                            "'"}
                    </div>
                )}

                {!window.LYSAGHT && (
                    <SegmentedButtonGroup
                        label={label2 + " Lining Alignment"}
                        tight
                        value={Number(gableParameters.InfillInset2)}
                        items={[
                            { Key: 0, Display: "Outside of Frame" },
                            { Key: 1, Display: "Inside of Frame" },
                        ]}
                        onChange={(e, value) => {
                            let error = dispatch(
                                updateAreaSpecificationGableParameters(Number(areaIndex), null, "InfillInset2", value)
                            );
                            if (error && error.error) {
                                openMessageBox(error?.title, <>{error.message}</>);
                            }
                        }}
                    />
                )}

                <SegmentedButtonGroup
                    label={label2 + " Strut"}
                    tight
                    value={Number(gableParameters.HasInfillStrut2)}
                    items={[
                        { Key: 0, Display: "No Strut" },
                        { Key: 1, Display: "Infill Strut" },
                    ]}
                    onChange={(e, value) => {
                        let error = dispatch(
                            updateAreaSpecificationGableParameters(Number(areaIndex), null, "HasInfillStrut2", value)
                        );
                        if (error && error.error) {
                            openMessageBox(error?.title, <>{error.message}</>);
                        }
                    }}
                />

                {designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && (
                    <BSL_TextInput
                        label={label2.replace("Infill", "") + " Frame Overhang"}
                        value={ShapeParameters?.OH_Right}
                        tight
                        min={0}
                        max={area_config?.max_frame_overhang ? area_config?.max_frame_overhang : 1200}
                        endAdornment="mm"
                        disabled={RoofType2 !== "Gable"}
                        style={{
                            maxWidth: "100px",
                        }}
                        onChange={(Value) => {
                            let error = dispatch(
                                updateAreaSpecificationShape(Number(areaIndex), null, "OH_Right", Value)
                            );
                        }}
                        disabledTooltip={"Only allowed for a Gable End Type"}
                    />
                )}

                {(areaSpecifications[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.HasRidgeBeam === 0 || window.LYSAGHT) &&
                    areaSpecifications[BASIC_SPECS_SECTIONS.SHAPE]?.OH_Right > 0 && (
                        <SegmentedButtonGroup
                            label={label2 + " Frame Overhang Position"}
                            tight
                            value={Number(gableParameters.InfillEndAlign2)}
                            items={
                                areaSpecifications[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.PortalPostType === 0
                                    ? [
                                          { Key: 1, Display: "At The End" },
                                          {
                                              Key: 0,
                                              Display: "Inset with Rafters at OH Setback",
                                          },
                                      ]
                                    : [
                                          { Key: 1, Display: "At The End, Rafters at OH Setback" },
                                          { Key: 2, Display: "At The End, No Rafters at OH Setback" },
                                          {
                                              Key: 0,
                                              Display: "Inset with Rafters at OH Setback",
                                          },
                                      ]
                            }
                            onChange={(e, value) => {
                                let error = dispatch(
                                    updateAreaSpecificationGableParameters(
                                        Number(areaIndex),
                                        null,
                                        "InfillEndAlign2",
                                        value
                                    )
                                );
                                if (error && error.error) {
                                    openMessageBox(error?.title, <>{error.message}</>);
                                }
                            }}
                        />
                    )}
            </BSL_Common.SectionContainer>

            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader>Other Flashing Options</BSL_Common.SectionHeader>
                <BSL_CheckBox
                    checked={Number(gableParameters.DownlightFlashing) === 1}
                    label={window.LYSAGHT ? "Allow Light Tray" : "Allow Downlight Flashing"}
                    onChange={(checked) => {
                        let error = dispatch(
                            updateAreaSpecificationGableParameters(
                                Number(areaIndex),
                                null,
                                "DownlightFlashing",
                                checked ? 1 : 0
                            )
                        );
                        if (error && error.error) {
                            openMessageBox(error?.title, <>{error.message}</>);
                        }
                    }}
                />
            </BSL_Common.SectionContainer>

            <BSL_Dialog
                title={dialogTitle}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                button1Text="OK"
                button1Click={() => setOpenDialog(false)}
            >
                {dialogMessage}
            </BSL_Dialog>
        </div>
    );
}
